module.exports = __webpack_public_path__ + "static/media/red_smile.7a7268b5.png";